import { render, staticRenderFns } from "./RegionSwitcher.vue?vue&type=template&id=b7372f2c&scoped=true&"
import script from "./RegionSwitcher.vue?vue&type=script&lang=js&"
export * from "./RegionSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./RegionSwitcher.vue?vue&type=style&index=0&id=b7372f2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7372f2c",
  null
  
)

export default component.exports